import SeoMetaHead from '@components/common/seo-meta-head';
import { performerCategoryService } from '@services/performer-category.service';
import { IPerformerCategory } from '@interfaces/performer-category';
import ModelRegisterForm from '@components/auth/model-register-form';
import Header from '@components/common/header/header';

type P = {
  categories: IPerformerCategory[]
}

function ModelRegister({ categories }: P) {
  return (
    <>
      <SeoMetaHead pageTitle="Creator sign up" />
      <Header hideAuthButtons />
      <ModelRegisterForm categories={categories} />
    </>
  );
}

ModelRegister.layout = 'public';
ModelRegister.authenticate = false;

export const getServerSideProps = async () => {
  const resp = await performerCategoryService.search({ limit: 200 });
  return {
    props: {
      categories: resp?.data?.data || []
    }
  };
};

export default ModelRegister;
